import { isDevMode } from '@angular/core';

import { readEnvelope, SchemaRootResolver } from './schema-root';

/**
 * `$source` — the state of the source the place reads: for a component, the nearest node above it declaring
 * `dataSource: { type }`. While that producer connects there is nothing to read, and nothing wrong.
 */
export const sourceRoot: SchemaRootResolver = {
  resolve(address, scope) {
    const source = scope.source();

    if (source === undefined) {
      reportMissingSource(address.text);

      return undefined;
    }

    if (address.keys.length === 0) {
      return source;
    }

    return source === null ? undefined : readEnvelope(address, source);
  },

  dataOf: (keys) => (keys[0] === 'data' ? { from: 'source', keys: keys.slice(1) } : null),
};

function reportMissingSource(text: string): void {
  if (isDevMode()) {
    console.warn(
      `Schema address "${text}" names "$source", but no data source is declared above this node, so it resolves ` +
        `to nothing. A node reads $source from the nearest node above it that declares dataSource: { type }.`
    );
  }
}
